import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const VendingMachine: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_285)">
                <IconPath
                    d="M19.5 21.75C21 21.75 21 20.25 21 20.25V2.25C21 0.75 19.5 0.75 19.5 0.75H4.5C3 0.75 3 2.25 3 2.25V20.25C3 21.75 4.5 21.75 4.5 21.75M19.5 21.75H4.5M19.5 21.75V23.25M4.5 21.75V23.25M15 0.75V21.75M6 18.75H12M18 3.75V5.25M18 8.25V9.75M18 17.25V18.75M6 3.75H12V15.75H6V3.75Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_285">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
